<template>
    <div>
        <base-header type="gradient-primary" class="pb-10 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->

        </base-header>

        <div class="container-fluid mt--7">
            <div class="card shadow bg-secondary">
                <div class="card-header">
                    <div class="row">
                        <div class="col-12 col-sm-6 align-self-center"><h3 class="mb-0">Company details</h3></div>
                        <div class="col-12 col-sm-6 text-right align-self-center">
                            <router-link :to="{ name: 'insurance companies' }" class=" btn btn-secondary mt-1">
                                <i class="fa fa-arrow-left"> Go to all companies</i>
                            </router-link>
                            <button class="btn btn-success text-white mt-1" v-on:click="UpdateForm()">
                                <i class="fas fa-save"> Save</i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body pt-0 pt-md-4">
                    <h6 class="heading-small text-muted mb-4">Company information</h6>
                    <div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group" v-if="errors.length">
                                    <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                        <ul>
                                            <li v-for="error in errors" :key="error['.key']">{{ error }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <base-input alternative=""
                                            label="Insurance company title"
                                            placeholder=""
                                            input-classes="form-control-alternative"
                                            v-model="company.title"
                                />
                            </div>
                            <div class="col-6">
                                <base-input alternative=""
                                            label="Insurance company phone number"
                                            placeholder=""
                                            input-classes="form-control-alternative"
                                            v-model="company.phone"
                                />
                            </div>
                            <div class="col-6">
                                <base-input alternative=""
                                            label="Insurance company email"
                                            placeholder=""
                                            type="email"
                                            input-classes="form-control-alternative"
                                            v-model="company.email"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import firebase from '../config/db.js';
    import swal from 'sweetalert2'

    export default {
        data() {
            return {
                id: this.$router.currentRoute.params.id,
                company: {
                    title: '',
                    phone: '',
                    email: ''
                },
                errors: []
            }
        },
        mounted: function () {
            if(this.id){
                this.getCompanyData();
            }
        },
        methods: {
            getCompanyData: function () {
                var that = this;
                firebase.firestore().collection("companies").doc(this.id).get().then((doc) => {
                    if (doc.exists) {
                        that.company = doc.data();
                    } else {
                        // doc.data() will be undefined in this case
                        swal.fire({
                            text: 'No such document!',
                            type: "error",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        that.$router.replace('insurance companies');
                    }
                });
            },
            UpdateForm: function () {
                this.errors = [];
                if (this.company.title == '') {
                    this.errors.push('Company title is required!');
                }
                if (this.company.email == '') {
                    this.errors.push('Company email is required!');
                }
                var that = this;
                if (this.errors.length == 0) {
                    if(this.id){
                        // Existing document
                        firebase.firestore().collection("companies").doc(this.id).update(that.company).then(function () {
                            swal.fire({
                                text: "Company updated successfully...",
                                type: "success",
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 1500
                            });
                            that.$router.push({name: 'insurance companies'})
                        }).catch(function (error) {
                            console.error("Error writing document: ", error);
                        });
                    }else{
                        // New document
                        firebase.firestore().collection("companies").doc().set(that.company).then(function () {
                            swal.fire({
                                text: "Company created successfully...",
                                type: "success",
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 1500
                            });
                            that.$router.push({name: 'insurance companies'})
                        }).catch(function (error) {
                            console.error("Error writing document: ", error);
                        });
                    }
                }
            }
        }
    };
</script>
<style></style>
